module.exports = __webpack_public_path__ + "static/media/3.286700a7.png";